import { render, staticRenderFns } from "./Pantalla.vue?vue&type=template&id=3b80a985&"
import script from "./Pantalla.vue?vue&type=script&lang=js&"
export * from "./Pantalla.vue?vue&type=script&lang=js&"
import style0 from "./Pantalla.vue?vue&type=style&index=0&id=3b80a985&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports